export const borderWidths = {
  '0': 0,
  '1': '1px',
  '2': '2px',
  '4': '4px',
  '8': '8px',
} as const;

export type BorderWidth = keyof typeof borderWidths;
